<script setup>
// A button for something that arrives in a later step of the product: shown, disabled, and it says so in a tooltip
// (a disabled button takes no pointer, so the tooltip hangs on the frame around it, which takes the keyboard focus).
import { useI18n } from 'vue-i18n';
import { Button } from '../ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

defineProps({
  variant: { type: String, default: 'outline' },
  size: { type: String, default: 'sm' },
  // the tooltip; the default says "In the next step"
  hint: { type: String, default: '' },
  // the button's name for assistive technology (the frame around the disabled button is what takes the focus)
  label: { type: String, required: true },
});
const { t } = useI18n();
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <span
          class="inline-flex rounded-polaris-md outline-none focus-visible:ring-[3px] focus-visible:ring-polaris-ring/50"
          role="group"
          tabindex="0"
          :aria-label="`${label}. ${hint || t('POLARIS.PREVIEW.NEXT_STEP')}`"
          data-upcoming
        >
          <Button
            type="button"
            :variant="variant"
            :size="size"
            disabled
            tabindex="-1"
          >
            <slot />
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        {{ hint || t('POLARIS.PREVIEW.NEXT_STEP') }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
